import { Badge } from "@chakra-ui/react";
import React from "react";

interface ScheduledUpdatesBadgeProps {
  scheduledUpdates: any[];
  field: string;
  hasScheduledUpdatesForField: (
    scheduledUpdates: any[],
    field: string
  ) => boolean;
}

export const ScheduledUpdatesBadge: React.FC<ScheduledUpdatesBadgeProps> = ({
  scheduledUpdates,
  field,
  hasScheduledUpdatesForField,
}) => {
  if (!hasScheduledUpdatesForField(scheduledUpdates, field)) return null;
  return (
    <Badge
      size="xs"
      fontSize="xs"
      colorScheme="blue"
      rounded="full"
      fontWeight={"medium"}
      px={2}
      textTransform={"initial"}
    >
      Scheduled update
    </Badge>
  );
};
